"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableError = void 0;
var _react = _interopRequireDefault(require("react"));
const TableError = _ref => {
  let {
    imgUrl,
    title,
    description
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "table--error__wrapper"
  }, imgUrl && /*#__PURE__*/_react.default.createElement("img", {
    src: imgUrl
  }), title && /*#__PURE__*/_react.default.createElement("h2", null, title), description && /*#__PURE__*/_react.default.createElement("p", null, description));
};
exports.TableError = TableError;